import CreditCardFormOfPaymentUIModel from './credit-card-form-of-payment';
import GiftCardFormOfPaymentUIModel from './gift-card-form-of-payment';
import EMDVoucherFormOfPaymentUIModel from './emd-voucher-form-of-payment';

class FormOfPaymentCollectionUIModel {
  constructor({
    _collection = undefined,
  } = {}) {
    this.hasEMDVoucherFormOfPayment = false;
    this.formsOfPayment = _collection.map(formOfPayment => {
      switch (formOfPayment._meta.class) {
        case 'CreditCardFormOfPayment':
          return new CreditCardFormOfPaymentUIModel(formOfPayment);
        case 'GiftCardFormOfPayment':
          return new GiftCardFormOfPaymentUIModel(formOfPayment);
        case 'EMDVoucherFormOfPayment':
          this.hasEMDVoucherFormOfPayment = true;
          return new EMDVoucherFormOfPaymentUIModel(formOfPayment);
        default:
          return {};
      }
    });
  }

  getPaymentTypesWithInstallments(emdInstallment) {
    return this.formsOfPayment.filter((paymentType) => {
      return paymentType.bankName && emdInstallment ? paymentType.installmentsEMD : paymentType.installments;
    });
  }

  getBankArrayByCardType(cardType, emdInstallment) {
    return this.getPaymentTypesWithInstallments(emdInstallment).filter(
      paymentType => paymentType.cardType === cardType
    ).map(paymentType => paymentType.bankName);
  }

  getInstallmentsByCardTypeAndBank(cardType, bankName, emdInstallment) {
    const paymentTypeArray = this.getPaymentTypesWithInstallments(emdInstallment);

    const paymentType = paymentTypeArray.find(
      paymentTypes => paymentTypes.bankName === bankName && paymentTypes.cardType === cardType
    );

    if (paymentType) {
      return emdInstallment ? paymentType.installmentsEMD : paymentType.installments;
    }

    return [];
  }
}

export default FormOfPaymentCollectionUIModel;
